// IoT 센서 지표 정의 — 서버 iotTelemetryService.METRIC_COLUMNS와 같은 8종을 공유한다.
// 서버가 화이트리스트를 강제하므로 이 모듈은 표시 메타(라벨·단위·소수 자리·구분색)만 담당한다.
// 센서 구분색 정본도 여기다 — 관리자 목록·상세가 같은 센서를 같은 색으로 쓰도록 한 곳에서 정의한다.
export const IOT_METRICS = Object.freeze([
    { key: 'pm1_0', label: 'PM1.0', unit: '㎍/㎥', fractionDigits: 2 },
    { key: 'pm2_5', label: 'PM2.5', unit: '㎍/㎥', fractionDigits: 2 },
    { key: 'pm10', label: 'PM10', unit: '㎍/㎥', fractionDigits: 2 },
    { key: 'voc', label: 'VOC', unit: 'mg/㎥', fractionDigits: 3 },
    { key: 'co2', label: 'CO2', unit: 'ppm', fractionDigits: 1 },
    { key: 'temperature', label: '온도', unit: '℃', fractionDigits: 2 },
    { key: 'humidity', label: '습도', unit: '%', fractionDigits: 2 },
    { key: 'ch2o', label: '폼알데하이드', unit: 'mg/㎥', fractionDigits: 3 }
]);

// 센서 구분색 — 관리자 목록의 최근값 도트와 상세의 차트 시리즈가 같은 센서를 같은 색으로 쓴다.
// 임의의 정상·위험 기준이 아니라 8종 구분용이다(스펙: IoT 센서 모니터링).
export const METRIC_COLORS = Object.freeze({
    pm1_0: '#64748b',
    pm2_5: '#f59e0b',
    pm10: '#ef4444',
    voc: '#8b5cf6',
    co2: '#0ea5e9',
    temperature: '#f97316',
    humidity: '#14b8a6',
    ch2o: '#ec4899'
});

export const IOT_METRIC_KEYS = Object.freeze(IOT_METRICS.map((metric) => metric.key));

export function metricMeta(key) {
    return IOT_METRICS.find((metric) => metric.key === key) || null;
}

export function formatMetricValue(key, value) {
    if (value === null || value === undefined || value === '') return '-';
    const numeric = Number(value);
    if (!Number.isFinite(numeric)) return '-';
    const meta = metricMeta(key);
    const digits = meta ? meta.fractionDigits : 2;
    return numeric.toFixed(digits);
}

// 서버는 KST 벽시계 문자열(`YYYY-MM-DDTHH:mm:ss+09:00`)을 준다. 파싱 실패 시 원문을 그대로 보여준다.
export function formatKstDateTime(value, { withSeconds = false } = {}) {
    if (!value) return '-';
    const parsed = Date.parse(value);
    if (!Number.isFinite(parsed)) return String(value);
    return new Intl.DateTimeFormat('ko-KR', {
        timeZone: 'Asia/Seoul',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        ...(withSeconds ? { second: '2-digit' } : {}),
        hour12: false
    }).format(parsed);
}

export function formatChartTick(value) {
    if (!value) return '';
    const parsed = Date.parse(value);
    if (!Number.isFinite(parsed)) return String(value);
    return new Intl.DateTimeFormat('ko-KR', {
        timeZone: 'Asia/Seoul',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
    }).format(parsed);
}
